<template>
  <div class="login-container">
    <div class="login-box">
      <h1>短信登录</h1>
      <h3>验证即登录，未注册将自动创建青牛出关账号</h3>
      <form @submit.prevent="handleLogin">
        <div class="input-group">
          <label for="phone">手机号:</label>
          <input
            type="text"
            v-model="phone"
            id="phone"
            @input="validatePhone"
            required
          />
          <span v-if="phoneError" class="error">{{ phoneError }}</span>
        </div>
        <div class="input-group">
          <label for="code">验证码:</label>
          <input
            style="max-width: 100px"
            type="text"
            v-model="code"
            id="code"
            required
          />
          <button
            type="button"
            @click="getCode"
            :disabled="isCodeButtonDisabled"
          >
            {{ codeButtonText }}
          </button>
        </div>
        <button type="submit" :disabled="!isFormValid || !isAgreementChecked">
          登录
        </button>

        <div class="agreement">
          <input
            type="checkbox"
            v-model="isAgreementChecked"
            id="agreement"
            required
          />
          <label for="agreement">
            我已阅读并同意
            <a @click="goWebUser">《青牛出关动漫网站用户协议》</a>
            和
            <a @click="goProtect">《个人信息保护政策》</a>
          </label>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
 import { EventBus } from '@/eventBus'; // 导入全局事件总线

import api from "../servies/api";
export default {
  data() {
    return {
      isAgreementChecked: false,
      phone: "",
      code: "",
      phoneError: "",
      isCodeButtonDisabled: false,
      codeButtonText: "获取验证码",
      isFormValid: false,
      countdown: 60,
    };
  },
  mounted() {},
  methods: {
    goProtect() {
      this.$router.push("infoproject");
    },
    goWebUser() {
      this.$router.push("webuser");
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    },
    validatePhone() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.phone)) {
        this.phoneError = "请输入有效的手机号";
        this.isFormValid = false;
      } else {
        this.phoneError = "";
        this.isFormValid = this.code !== "";
      }
    },
    requestCode() {
      let params = {
        phone: this.phone,
      };
      api
        .getCode(params)
        .then((res) => {
          console.log("验证码请求成功", res);
        })
        .catch((err) => {
          console.log("验证码请求失败", err);
        });
    },
    /**
     * 登录
     */
    requestLogin() {
      console.log("isAgreementChecked", this.isAgreementChecked);
      let params = {
        phone: this.phone,

        code: this.code,
      };
      api
        .postLogin(params)
        .then((res) => {
          if (res.code !== 0) {
            alert(res.msg);
            return;
          }
          console.log("登录成功！！！！", res);
          // EventBus.$emit('login-success'); // 触发事件
           EventBus.$emit("update-message", res.resultData.name);
          localStorage.setItem("isIdentify", res.resultData.idNo.length> 0);

          this.$router.push("/home");
          localStorage.setItem("name", res.resultData.name);

          this.setCookie("authToken", res.resultData.token || "", 7);
        })
        .catch((err) => {
          console.log("登录失败", err);
        });
    },
    getCode() {
      if (this.phoneError) {
        alert("请输入有效的手机号");
        return;
      }
      this.isCodeButtonDisabled = true;
      this.codeButtonText = `${this.countdown}s`;
      this.requestCode();
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown > 0) {
          this.codeButtonText = `${this.countdown}s`;
        } else {
          clearInterval(interval);
          this.isCodeButtonDisabled = false;
          this.codeButtonText = "获取验证码";
          this.countdown = 60;
        }
      }, 1000);
      // 模拟发送验证码
      // alert("验证码已发送");
    },
    handleLogin() {
      if (this.phone && this.code) {
        this.requestLogin();
      } else {
        alert("请输入手机号和验证码");
      }
    },
  },
  watch: {
    code(newCode) {
      this.isFormValid = newCode !== "" && this.phoneError === "";
    },
  },
};
</script>

<style lang='less'>
.login-container {
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 550px;
  text-align: center;
  margin: 130px auto;

  h1 {
    margin-bottom: 30px;
    color: #333;
    font-size: 24px;
    font-weight: 600;
  }
  h3 {
    margin-bottom: 20px;
    color: #666;
    font-size: 14px;
  }
}
a {
  color: blue;
  text-decoration: none;
  cursor: pointer;
}

a:hover {
  text-decoration: none;
}

.input-group {
  margin-bottom: 20px;
  text-align: left;

  label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-size: 14px;
  }

  input {
    width: calc(100% - 120px);
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 14px;
    max-width: 300px;
  }

  button {
    width: 100px;
    padding: 12px;
    background-color: #007bff;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    margin-left: 10px;
    transition: background-color 0.3s ease;

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background-color: #0056b3;
    }
  }
}
.agreement {
  margin-top: 20px;
}
button {
  width: 100%;
  padding: 14px;
  background-color: #28a745;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: #218838;
  }
}

.error {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue